import { render, staticRenderFns } from "./RegularDateSelector.vue?vue&type=template&id=520e7ffc"
import script from "./RegularDateSelector.vue?vue&type=script&lang=js"
export * from "./RegularDateSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports